<template>
<m-pageframe
    title="OAuth Integrations"
>
<v-container
    fluid
    style="padding: 15px"
>
    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
    >
        <v-menu
            bottom
            offset-y
            slot="append-outer"
        >
            <template v-slot:activator="{ on }">
                <v-icon
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
            </template>
    
            <v-list>
                <v-list-item
                    v-on:click="onClickNew()"
                >
                    <v-list-item-title>New integration...</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu> 
    </v-text-field>

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >
    
        <template v-slot:item.time_access_token="{ item }">
            {{$rc.pretty(item.time_access_token,'time')}}
        </template>

        <template v-slot:item.time_access_token_expire="{ item }">
            {{$rc.pretty(item.time_access_token_expire,'time')}}
        </template>
    
    </v-data-table>

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');

export default {
    data() {
        return {
            full_text: null,

            headers: [
                { text: 'Type', value: 'integration_type'},
                { text: 'Username', value: 'integration_username'},
                { text: 'Issued', value: 'time_access_token'},
                { text: 'Expires', value: 'time_access_token_expire'},
            ],

            results: [],
        }
    },

    mounted () {
        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/integrations/oauth',
            
                'params' : {
                        'employee_id': this.$route.params.employee_id,
                    },
            
                'on_success': (data) => {
                        this.results = data.results;
                    },
            
                'on_error': 'Unable to list oauth tokens',
            });
        },

        onClickNew()
        {
            this.$rc.promptSelect({
                'title': 'Add Integration',
                'label': 'Integration',
                'items': this.$rc.enumChoices('oauth_token_type',false),
                'after_prompt': (value) => 
                {
                    this.onNewIntegration(value);
                }
            });
        },

        onNewIntegration(type)
        {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PUT: /api/v1/integrations/oauth/start-auth',
            
                'params' : {
                        'integration_type': type,
                        'employee_id': this.$route.params.employee_id,
                    },
            
                'on_success': (data) => {
                        window.location = data.url;
                    },
            
                'on_error': 'Unable to start OAuth pairing.',
            });
        }
    },
    
}
</script>

<style lang="scss" scoped>
</style>